<div class="page-main">
  <h3>{{ 'global.your_skills_profile' | translate }}</h3>
  <button class="print-page-btn" (click)="openPrint()">{{ 'global.print_this_page' | translate }}</button>
  <bwh-lib-personal-data
    class="print-styles pagebreak"
    [form]="form"
    [cvSharing]="cvSharing"
    (editPersonalData)="editPersonalData()"
  ></bwh-lib-personal-data>

  <div class="accordion-section print-styles pagebreak">
    <div class="accordion-header" (click)="toggleSection('knowledge_skills')">
      <span class="accordion-title">{{ 'global.knowledge_and_skills' | translate }}</span>
      <div class="accordion-header-actions">
        <button
          type="button"
          class="inline-edit-toggle"
          *ngIf="knowledgeSkills.length > 0 && !cvSharing"
          (click)="toggleInlineEditing('knowledge_skills'); $event.stopPropagation()"
        >
          <img src="/assets/icons/edit-icon.svg" alt="" />
          {{ isInlineEditing('knowledge_skills') ? ('global.done' | translate) : ('global.edit' | translate) }}
        </button>
        <button
          type="button"
          class="add-skill-button"
          *ngIf="isInlineEditing('knowledge_skills') && knowledgeSkills.length > 0 && !cvSharing"
          (click)="editSkillsFiltered('knowledge_skills'); $event.stopPropagation()"
          [attr.aria-label]="'global.add_skills' | translate"
        >
          +
        </button>

        <img
          class="accordion-chevron"
          [class.collapsed]="!isSectionExpanded('knowledge_skills')"
          src="/assets/icons/icon-down-b.svg"
          alt=""
        />
      </div>
    </div>
    <div class="accordion-body" *ngIf="isSectionExpanded('knowledge_skills')">
      <bwh-lib-skills-edition
        [form]="form"
        [control]="'knowledge_skills'"
        [title]="'global.knowledge_and_skills' | translate"
        [showHeader]="false"
        [infoTxt]="'global.add_your_skills_so_we_will_match_jobs_better' | translate"
        [buttonTxt]="'global.add_your_knowledge_skills' | translate"
        [cvSharing]="cvSharing"
        [inlineEditing]="isInlineEditing('knowledge_skills')"
        [reordering]="isReordering('knowledge_skills')"
        [maxDisplay]="MAX_KNOWLEDGE"
        [sortEnabled]="false"
        [separatorAfterIndex]="isInlineEditing('knowledge_skills') ? 11 : -1"
        (clickEdit)="editSkillsFiltered('knowledge_skills')"
        (ratingChanged)="changeSkillRating($event)"
        (deleteSkill)="deleteSkillInline('knowledge_skills', $event)"
        (reordered)="onSkillsReordered('knowledge_skills')"
      ></bwh-lib-skills-edition>
    </div>
  </div>

  <div class="accordion-section print-styles pagebreak">
    <div class="accordion-header" (click)="toggleSection('soft_skills')">
      <span class="accordion-title">{{ 'global.soft_skills' | translate }}</span>
      <div class="accordion-header-actions">
        <button
          type="button"
          class="inline-edit-toggle"
          *ngIf="softSkills.length > 0 && !cvSharing"
          (click)="toggleInlineEditing('soft_skills'); $event.stopPropagation()"
        >
          <img src="/assets/icons/edit-icon.svg" alt="" />
          {{ isInlineEditing('soft_skills') ? ('global.done' | translate) : ('global.edit' | translate) }}
        </button>
        <button
          type="button"
          class="add-skill-button"
          *ngIf="isInlineEditing('soft_skills') && softSkills.length > 0 && !cvSharing"
          (click)="editSkillsFiltered('soft_skills'); $event.stopPropagation()"
          [attr.aria-label]="'global.add_skills' | translate"
        >
          +
        </button>

        <img
          class="accordion-chevron"
          [class.collapsed]="!isSectionExpanded('soft_skills')"
          src="/assets/icons/icon-down-b.svg"
          alt=""
        />
      </div>
    </div>
    <div class="accordion-body" *ngIf="isSectionExpanded('soft_skills')">
      <bwh-lib-skills-edition
        [form]="form"
        [control]="'soft_skills'"
        [title]="'global.soft_skills' | translate"
        [showHeader]="false"
        [infoTxt]="'global.add_your_soft_skills_so_we_will_match_jobs_better' | translate"
        [buttonTxt]="'global.add_your_soft_skills' | translate"
        [cvSharing]="cvSharing"
        [inlineEditing]="isInlineEditing('soft_skills')"
        [reordering]="isReordering('soft_skills')"
        [maxDisplay]="6"
        [sortEnabled]="false"
        [separatorAfterIndex]="isInlineEditing('soft_skills') ? 5 : -1"
        (clickEdit)="editSkillsFiltered('soft_skills')"
        (ratingChanged)="changeSkillRating($event)"
        (deleteSkill)="deleteSkillInline('soft_skills', $event)"
        (reordered)="onSkillsReordered('soft_skills')"
      ></bwh-lib-skills-edition>
    </div>
  </div>
  <div class="accordion-section print-styles pagebreak">
    <div class="accordion-header" (click)="toggleSection('languages')">
      <span class="accordion-title">{{ 'global.languages' | translate }}</span>
      <div class="accordion-header-actions">
        <button
          type="button"
          class="inline-edit-toggle"
          *ngIf="languages.length > 0 && !cvSharing"
          (click)="toggleInlineEditing('languages'); $event.stopPropagation()"
        >
          <img src="/assets/icons/edit-icon.svg" alt="" />
          {{ isInlineEditing('languages') ? ('global.done' | translate) : ('global.edit' | translate) }}
        </button>
        <button
          type="button"
          class="add-skill-button"
          *ngIf="isInlineEditing('languages') && languages.length > 0 && !cvSharing"
          (click)="editSkills('languages'); $event.stopPropagation()"
          [attr.aria-label]="'global.add_skills' | translate"
        >
          +
        </button>

        <img
          class="accordion-chevron"
          [class.collapsed]="!isSectionExpanded('languages')"
          src="/assets/icons/icon-down-b.svg"
          alt=""
        />
      </div>
    </div>
    <div class="accordion-body" *ngIf="isSectionExpanded('languages')">
      <bwh-lib-skills-edition
        [form]="form"
        [control]="'languages'"
        [title]="'global.languages' | translate"
        [showHeader]="false"
        [infoTxt]="'global.add_your_languages_so_we_will_match_jobs_better' | translate"
        [buttonTxt]="'global.add_your_languages' | translate"
        [cvSharing]="cvSharing"
        [inlineEditing]="isInlineEditing('languages')"
        [reordering]="isReordering('languages')"
        (clickEdit)="editSkills($event)"
        (ratingChanged)="changeSkillRating($event)"
        (deleteSkill)="deleteSkillInline('languages', $event)"
        (reordered)="onSkillsReordered('languages')"
      ></bwh-lib-skills-edition>
    </div>
  </div>
  <!-- <bwh-lib-skills-edition
    class="print-styles pagebreak"
    [form]="form"
    [control]="'professional_skills'"
    [title]="'global.professional_skills' | translate"
    [infoTxt]="'global.add_your_skills_so_we_will_match_jobs_better' | translate"
    [buttonTxt]="'global.add_your_professional_skills' | translate"
    [blockGoToEditionBtn]="work_history.length === 0 && education.length === 0"
    [additionalBtnInfo]="'global.prof_skills_add_info_btn' | translate"
    [cvSharing]="cvSharing"
    (clickEdit)="editSkills($event)"
    (ratingChanged)="changeSkillRating($event)"
  ></bwh-lib-skills-edition> -->

  <!-- <bwh-lib-skills-edition
    class="print-styles pagebreak"
    [form]="form"
    [control]="'it_skills'"
    [title]="'global.it_skills' | translate"
    [infoTxt]="'global.add_your_skills_so_we_will_match_jobs_better' | translate"
    [buttonTxt]="'global.add_your_it_skills' | translate"
    [blockGoToEditionBtn]="work_history.length === 0 && education.length === 0"
    [additionalBtnInfo]="'global.prof_skills_add_info_btn' | translate"
    [cvSharing]="cvSharing"
    (clickEdit)="editSkills($event)"
    (ratingChanged)="changeSkillRating($event)"
  ></bwh-lib-skills-edition> -->

  <!-- <bwh-lib-skills-edition
    class="print-styles pagebreak"
    [form]="form"
    [control]="'task_skills'"
    [title]="'global.tasks' | translate"
    [infoTxt]="'global.add_your_skills_so_we_will_match_jobs_better' | translate"
    [buttonTxt]="'global.add_your_tasks' | translate"
    [blockGoToEditionBtn]="work_history.length === 0 && education.length === 0"
    [additionalBtnInfo]="'global.prof_skills_add_info_btn' | translate"
    [cvSharing]="cvSharing"
    (clickEdit)="editSkills($event)"
    (ratingChanged)="changeSkillRating($event)"
  ></bwh-lib-skills-edition> -->

  <div class="accordion-section print-styles pagebreak">
    <div class="accordion-header" (click)="toggleSection('work_history')">
      <span class="accordion-title">{{ 'global.your_experience' | translate }}</span>
      <div class="accordion-header-actions">
        <div
          class="edit-button"
          *ngIf="work_history.length > 0 && !cvSharing"
          (click)="editSkills('your_experience'); $event.stopPropagation()"
        >
          <img src="/assets/icons/edit-icon.svg" alt="" />{{ 'global.edit' | translate }}
        </div>
        <img
          class="accordion-chevron"
          [class.collapsed]="!isSectionExpanded('work_history')"
          src="/assets/icons/icon-down-b.svg"
          alt=""
        />
      </div>
    </div>
    <div class="accordion-body" *ngIf="isSectionExpanded('work_history')">
      <bwh-lib-skills-edition
        [form]="form"
        [control]="'work_history'"
        [editName]="'your_experience'"
        [title]="'global.your_experience' | translate"
        [showHeader]="false"
        [infoTxt]="'global.add_your_experience_so_we_will_match_jobs_better' | translate"
        [buttonTxt]="'global.add_your_experience' | translate"
        [cvSharing]="cvSharing"
        (clickEdit)="editSkills($event)"
      ></bwh-lib-skills-edition>
    </div>
  </div>

  <div class="accordion-section print-styles pagebreak">
    <div class="accordion-header" (click)="toggleSection('education')">
      <span class="accordion-title">{{ 'global.your_education' | translate }}</span>
      <div class="accordion-header-actions">
        <div
          class="edit-button"
          *ngIf="education.length > 0 && !cvSharing"
          (click)="editSkills('education'); $event.stopPropagation()"
        >
          <img src="/assets/icons/edit-icon.svg" alt="" />{{ 'global.edit' | translate }}
        </div>
        <img
          class="accordion-chevron"
          [class.collapsed]="!isSectionExpanded('education')"
          src="/assets/icons/icon-down-b.svg"
          alt=""
        />
      </div>
    </div>
    <div class="accordion-body" *ngIf="isSectionExpanded('education')">
      <bwh-lib-skills-edition
        [form]="form"
        [control]="'education'"
        [title]="'global.your_education' | translate"
        [showHeader]="false"
        [infoTxt]="'global.add_your_education_so_we_will_match_jobs_better' | translate"
        [buttonTxt]="'global.add_your_education' | translate"
        [cvSharing]="cvSharing"
        [levelOptions]="levelOptions"
        (clickEdit)="editSkills($event)"
      ></bwh-lib-skills-edition>
    </div>
  </div>
</div>

<div class="page-right">
  <div class="spinner-container p-absolute" *ngIf="checkingIfApply">
    <mat-spinner class="primary" [diameter]="30"></mat-spinner>
  </div>
  <div class="button-cont" *ngIf="accountDataChecked && !cvSharing">
    <bwc-vacancy-apply
      [vacancyDetails]="vacancyDetails"
      [isActivated]="isActivated"
      [alreadyApplied]="alreadyApplied"
      [showApplyCont]="showApplyCont"
      [showApplyOFLCont]="showApplyOFLCont"
      (applyClicked)="applyForTheJob()"
    ></bwc-vacancy-apply>
  </div>
  <bwc-skills-completion></bwc-skills-completion>
  <bwc-work-preferences *ngIf="!cvSharing"></bwc-work-preferences>
  <bwc-profile-visibility [accountActivated]="isActivated" *ngIf="!cvSharing"></bwc-profile-visibility>
</div>

<div class="edit-container" *ngIf="showEditCont">
  <div class="edit-in-container">
    <bwc-general-information
      *ngIf="isEditPanelActive('gen_info')"
      [formGroup]="form"
      [prevBut]="false"
      [accountActivated]="isActivated"
      [closeBut]="false"
      [editing]="true"
      (formEmit)="getEditedForm($event)"
      (emitClose)="closeEditCont($event)"
      class="fixed-size"
    ></bwc-general-information>

    <bwc-soft-skills
      *ngIf="isEditPanelActive('soft_skills')"
      [formGroup]="form"
      [prevBut]="false"
      [closeBut]="false"
      [editing]="true"
      (emitSkills)="getEditedSkills($event, 'softSkills')"
      (emitClose)="closeEditCont($event)"
      class="fixed-size"
    ></bwc-soft-skills>

    <bwc-knowledge-skills
      *ngIf="isEditPanelActive('knowledge_skills')"
      [formGroup]="form"
      [prevBut]="false"
      [closeBut]="false"
      [editing]="true"
      (emitSkills)="getEditedSkills($event, 'knowledgeSkills')"
      (emitClose)="closeEditCont($event)"
      class="fixed-size"
    ></bwc-knowledge-skills>

    <bwc-professional-skills
      *ngIf="isEditPanelActive('professional_skills')"
      [formGroup]="form"
      [prevBut]="false"
      [closeBut]="false"
      [editing]="true"
      (emitSkills)="getEditedSkills($event, 'profSkills')"
      (emitClose)="closeEditCont($event)"
      class="fixed-size"
    ></bwc-professional-skills>

    <!-- <bwc-it-skills
      *ngIf="show_it_skills"
      [formGroup]="form"
      [prevBut]="false"
      [closeBut]="false"
      [editing]="true"
      (emitSkills)="getEditedSkills($event, 'itSkills')"
      (emitClose)="closeEditCont($event)"
      class="fixed-size"
    ></bwc-it-skills> -->

    <bwc-tasks
      *ngIf="isEditPanelActive('task_skills')"
      [formGroup]="form"
      [prevBut]="false"
      [closeBut]="false"
      [editing]="true"
      (emitSkills)="getEditedSkills($event, 'taskSkills')"
      (emitClose)="closeEditCont($event)"
      class="fixed-size"
    ></bwc-tasks>

    <bwc-select-your-job
      *ngIf="isEditPanelActive('your_experience')"
      [formGroup]="form"
      [editing]="true"
      [prevBut]="false"
      [closeBut]="false"
      [itemClickable]="true"
      (emitExp)="getEditedJob($event)"
      (emitClose)="closeEditCont($event)"
      (clickEdit)="editSkills($event)"
      class="fixed-size"
    ></bwc-select-your-job>

    <bwc-add-your-education
      *ngIf="isEditPanelActive('education')"
      [formGroup]="form"
      [prevBut]="false"
      [closeBut]="false"
      [editing]="true"
      [saveToDB]="true"
      (emitEducation)="getEditedEducation($event)"
      (emitClose)="closeEditCont($event)"
      class="fixed-size"
    ></bwc-add-your-education>

    <bwc-languages-knowledge
      *ngIf="isEditPanelActive('languages')"
      [formGroup]="form"
      [prevBut]="false"
      [closeBut]="false"
      [editing]="true"
      [removeProfileCheckClass]="false"
      (emitLanguages)="getEditedLanguages($event)"
      (emitClose)="closeEditCont($event)"
      class="fixed-size"
    ></bwc-languages-knowledge>

    <bwc-search-add-skills
      *ngIf="isEditPanelActive('search_add_skills')"
      [prevBut]="true"
      [closeBut]="false"
      [editing]="false"
      [disableNext]="true"
      [sectionTitle]="activeSectionTitle"
      [excludeSkillType]="activeExcludeSkillType"
      (emitClose)="closeEditCont($event)"
      class="fixed-size"
    ></bwc-search-add-skills>

    <bwc-create-account
      *ngIf="isEditPanelActive('create_account')"
      [prevBut]="false"
      [closeBut]="false"
      (emitClose)="closeEditCont($event)"
      class="fixed-size"
    ></bwc-create-account>
  </div>
</div>
<footer class="fixed-footer" *ngIf="accountDataChecked && !cvSharing">
  <button
    type="button"
    class="btn w-lg h-lg purple footer-btn"
    (click)="activeSectionTitle = ''; activeExcludeSkillType = [SkillType.Language]; editSkills('search_add_skills')"
  >
    + {{ 'global.add_skills' | translate }}
  </button>

  <button
    *ngIf="!isActivated"
    type="button"
    class="btn w-lg h-lg secondary footer-btn breathing-button"
    (click)="onCreateAccount()"
  >
    {{ 'global.create_account' | translate }}
  </button>

  <button
    type="button"
    class="btn w-lg h-lg footer-btn footer-btn-outline"
    [disabled]="!isActivated"
    (click)="shareCv()"
  >
    <span class="footer-btn-icon" [inlineSVG]="'/icons/share-arrow-icon.svg'"></span>
    {{ 'global.share' | translate }}
  </button>
</footer>

<span class="saving-indicator" *ngIf="isSaving">
  <mat-spinner class="primary" [diameter]="14"></mat-spinner>
  {{ 'global.saving' | translate }}
</span>
<span class="saved-indicator" *ngIf="!isSaving && showSavedIndicator">{{ 'global.saved' | translate }}</span>

<bwc-share-modal *ngIf="showShareModal" [userId]="userId" (closed)="closeShareModal()"></bwc-share-modal>
